<template>
  <static-fullscreen-card>
    <template v-slot:title> ({{ data.id }}) {{ data.name }} [{{ statusCurrent.text }}] </template>
    <template v-slot:actions>
      <a-btn-add
        v-if="canEdit && !['ready', 'cancel'].includes(statusCurrent.status)"
        @click="showRedirectDialog = true"
        :disabled="loading"
        icon="fas fa-people-arrows"
        title=""
      />
      <a-btn-status v-if="canStatus" :items="[...statusTaskItems]" @click="clickStatus($event)" :status1="statusCurrent.value" :disabled="loading" />
      <a-btn-edit v-if="canEdit" @click="showEditDialog = true" :disabled="loading" />
    </template>
    <portal to="v-main">
      <edit-dialog v-model="showEditDialog" :id="id" :api="api" @close="itemShowClose($event)" :status="statusCurrent"></edit-dialog>
    </portal>
    <portal to="v-goup" v-if="idShow">
      <v-btn class="mr-3" fab small @click="$emit('close', data)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <v-row>
      <v-col cols="12" sm="6" class="px-2">
        <material-card color="secondary">
          <template v-slot:heading>
            <div class="px-3 py-1">Задача [{{ statusCurrent.text }}]</div>
          </template>
          <a-form-view
            :value="data"
            :model="[
              {
                name: 'document',
                title: 'Документ',
                type: 'selectapi',
                itemField: { value: 'id', text: 'code_doc' },
                api: 'accounting/doc/order_good',
                routeName: 'ordersGoods_view',
                preText: 'Заказ товаров №',
                value: constructionGoodsTable ? constructionGoodsTable.doc_id || 0 : 0,
                isMenu: true,
              },

              ...getFormModel(['type', 'name', 'is_important', 'description']),
            ]"
            :config="{ dense: true, hideNull: true }"
            :style="{ height: blockHeight + 'px' }"
            @click="onClick($event)"
          />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6" class="px-2">
        <material-card color="secondary">
          <template v-slot:heading>
            <div class="px-3 py-1">Состояние</div>
          </template>
          <a-form-view :value="data" :model="modelRight" :config="{ dense: true, hideNull: !false, showNull: true }" class="block_master" @click="onClick($event)" />
        </material-card>
      </v-col>
      <v-col cols="12" class="px-2">
        <material-card color="third" class="block_detail">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color="white">
              <v-tab v-for="(t, i) in tabs" :key="i" v-if="t.show" :href="`#tab-${t.name}`" class="mr-3">{{ t.title }}</v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px" touchless>
            <v-tab-item v-for="(t, i) in tabs" :key="i" v-if="t.show" :id="`tab-${t.name}`">
              <v-card-text v-if="t.name == 'files'" :style="`height: ${detailHeight}px; overflow: auto`">
                <v-fab-transition>
                  <v-btn
                    v-if="docEdit"
                    :disabled="loading"
                    fab
                    dark
                    color="green"
                    absolute
                    bottom
                    x-small
                    style="bottom: 15px"
                    left
                    class="v-btn--example"
                    @click="showAddFilesDialog = true"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-fab-transition>
                <a-view-files :value="data.files" />
                <a-view-filesDialog v-if="showAddFilesDialog" v-model="showAddFilesDialog" :files="data.files" @save="addNewFiles($event)" />
              </v-card-text>

              <comment-view v-if="t.name == 'comments'" :height="detailHeight" :id="id || 0" :targetName="'tasks'" :needUpdate="needUpdateComments" />
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
    <div v-if="loading" class="loading-block">
      <div class="loader"></div>
    </div>
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <RedirectTask v-if="showRedirectDialog" v-model="showRedirectDialog" @redirect="onRedirect($event)" />
    <comment-edit
      :value="showAddCommentDialog"
      @input="
        showAddCommentDialog = false;
        changeStatus(newStatus, $event);
      "
      :id="0"
      :target="{ id, name: 'tasks' }"
    />
    <a-loader v-if="loading" />
    <popup-menu v-model="popumMenuShow" :items="popupMenuList" :position="popupMenuPosition" @click="onClickMenu($event)" />
  </static-fullscreen-card>
</template>

<script>
//import { statusTask } from "@/config/modules/libs";

import { autoHeightBlock, getAccess, popupMenu, genModel } from "../../components/mixings";
export default {
  mixins: [autoHeightBlock, getAccess, popupMenu, genModel],
  components: {
    editDialog: () => import("./../dialogs/taskDialog"),
    RedirectTask: () => import("./../dialogs/taskRedirectDialog"),
  },
  props: {
    idShow: Number,
    api: { type: String, default: "/mechti/tasks" },
  },
  data() {
    return {
      id: 0,
      needUpdateComments: 0,
      showEditDialog: false,
      showRedirectDialog: false,
      showAddCommentDialog: false,
      showAddFilesDialog: false,
      loading: false,
      title: "",
      data: {},
      model__: this.$store.getters["config/get"].models.tasks.form,
      m: this.$store.getters["config/get"].models.tasks,
      statusTask: JSON.parse(JSON.stringify(this.$store.getters["config/get"].models.tasks.statuses)),
      url: this.api,
      tab: 0,
      tabs: [
        { name: "files", title: "Файлы", show: true },
        { name: "comments", title: "Комментарии", show: this.getAccess(`task.comments`, null, true) },
      ],
      blockHeight: 256,
      newStatus: null,
      constructionGoodsTable: null,
      statusUser: null,
      //statusCurrent_: {},
    };
  },
  created() {
    this.$root.title = "Задача";
    this.id = this.idShow || Number(this.$route.params.id);
    if (this.idShow) {
      // this.$router.push({ path: this.$route.path + `/${this.idShow}` });
    }
    this.fitchData();
  },
  mounted() {},

  computed: {
    overseer() {
      return this.getAccess("task.viewOverseer");
    },
    model() {
      const res = this.getModelList(this.m, "form");
      return res;
    },
    canStatus() {
      if (this?.data?.type == "auto") return false;
      return this.getAccess("task.status", { users: this.statusUser });
    },
    canEdit() {
      if (this?.data?.type == "auto") return false;
      return this.getAccess("task.edit", { users: [this.data.user_id], data: this.data });
    },
    constructionGoodsData() {
      if (!this.constructionGoodsTable) this.getConstructionGoodsTable();
      return this.constructionGoodsTable;
    },

    filters() {
      return {
        object_id: this.data.object_id,
        params: {
          condition: "LIKE",
          value: '%"parent_id":' + (this.data.params?.parent_id || 0) + "%",
        },
      };
    },
    statuses() {
      return this.statusTask;
    },
    statusTaskItems() {
      let items = [];
      let res = [];
      if (this.statusCurrent?.["next"]) {
        let arr = this.statusCurrent["next"];

        res = this.statuses.filter(s => {
          s.disabled = s.status == "ready" && this.data.needs_checking && this.statusCurrent.status != "checking";
          return arr.includes(s.value);
        });
      }
      items = JSON.parse(JSON.stringify(res));
      return items;
    },
    statusCurrent() {
      let idx = this.statuses.findIndex(el => {
        return el.value == this.data.status || 0;
      });

      if (idx == -1) return {};

      return JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    docEdit() {
      if (!this.data) return false;
      let u = [this.data.user_id];
      if (this.data.watchers) {
        this.data.watchers.forEach(w => {
          u.push(w.user_id);
        });
      }
      let res = this.getAccess("task.edit", { users: u, data: this.data });
      return res;
    },
    modelRight() {
      let model = this.calcModel("viewFormRight");
      return model;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
      }
    },
    "data.status"() {
      this.needUpdateComments++;
    },
    statusCurrent(v) {
      this.setStatusUser();
    },
  },
  methods: {
    afterFetchData(data) {
      //this.statusCurrent_ = null;
      let idx = this.statuses.findIndex(el => {
        return el.value == this.data.status || 0;
      });
      //if (idx >= 0) this.statusCurrent_ = JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    async onRedirect(data) {
      data["id"] = this.id;
      this.loading = true;
      let response = await this.$axios.post("/mechti/tasks/redirect", data);
      this.loading = false;
      let status = response.data.status == "ok";
      if (status) {
        this.$root.$emit("show-info", {
          text: "Задача переназначена",
        });
        this.fitchData();
        this.needUpdateComments++;
      } else {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка при переназначении",
        });
      }
    },
    setStatusUser() {
      let res = [];
      (this.statusCurrent?.users || "user_id,createdby_id").split(",").forEach(u => res.push(this.data?.[u]));

      this.statusUser = res;
    },
    itemShowClose() {
      if (this.idShow) this.$emit("close");
      else this.$router.push({ name: this.$route.path.split("/")[1] });
    },
    async getConstructionGoodsTable() {
      let res;
      let d = await this.$axios.get("mechti/construction-goods/" + (this.data.params.parent_id || 0));
      if (d.data && d.data.data) {
        res = d.data.data;
      }
      this.constructionGoodsTable = res;
    },
    async fitchData() {
      this.loading = true;
      try {
        const d = await this.$axios.get(this.url + "/" + this.id);
        if (d.data && d.data.data) {
          this.data = d.data.data;
        }
      } catch (error) {
        if (this.idShow) this.$emit("close");
        else this.$router.push({ name: this.$route.path.split("/")[1] });
        throw error;
      }
      this.afterFetchData(this.data);
      this.loading = !true;
      this.$store.dispatch("state/badges", "task_items");
    },
    getFormModel(arr) {
      let res = [];
      let model = this.model.copy();
      arr.forEach(el => {
        let r = model.filter(m => {
          return m.name == el;
        })[0];
        if (r.hidden) r.hidden = false;
        res = [...res, r];
      });
      return res;
    },
    getModel(type) {
      let model = [];
      if (type == 2) {
        model = this.getFormModel(["createdon", "date_start", "date_end", "createdby_id", "user_id"]);
        if (this.data?.object_name) {
          model = [{ name: "object_name", title: "Объект", type: "string", isMenu: true }, ...model];
        }
      }
      return model;
    },
    onClick(e) {
      if (e.field?.isMenu) {
        this.showPopupMenu(e.field.name, e.row, e.event, e);
      }
    },
    async clickStatus(status) {
      this.newStatus = null;
      if (!this.data.user_id) {
        this.$root.$emit("show-info", {
          text: "У задачи нет исполнителя.",
          type: "error",
        });

        return;
      }

      let ok = false;
      if (status?.rules?.formula) {
        let rule = eval(status.rules.formula);
        // rule = eval(formula);
        if (rule && !rule(this.data)) {
          let text = status?.rules?.text || "Нет прав для переключения в этот статус";

          const res = rule(this.data, "text");
          if (res) text = res;
          console.log("res", res);
          this.$root.$emit("show-info", {
            text,
            type: "error",
          });
          return;
        }
      }
      ok = await this.$refs.confirmDialog.show({
        title: "Изменение статуса",
        message: [`Вы действительно хотите поменять статус на [${status.text}]?`],
        okButton: "Да",
        cancelButton: "Нет",
      });
      if (!ok) return;
      if (status.func) {
        this[status.func](status);
      } else {
        this.changeStatus(status);
      }
      this.fitchData();
    },

    statusAddComment(status) {
      this.newStatus = status;
      this.showAddCommentDialog = true;
    },

    async changeStatus(status) {
      this.loading = true;
      let data = { id: this.data.id, status: status.value };
      let response = await this.$axios.post(this.url, data);
      this.loading = false;
      this.fitchData();
      let res = response.data.status == "ok";
      if (res) {
        Object.assign(this.data, response.data.data);
        this.$root.$emit("show-info", {
          text: "Статус изменен",
        });
      }
    },
    async addNewFiles(files) {
      this.loading = true;
      let data = { id: this.data.id, files };
      let response = await this.$axios.post(this.url, data);
      this.loading = false;

      const status = response.data.status == "ok";
      if (response.data.data) {
        Object.assign(this.data, response.data.data);
        this.$root.$emit("show-info", {
          text: "Файлы добавлены",
        });
      }
    },
  },
};
</script>
